const loading = {
  animation: 'timeline',
  animationDuration: '1.2s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
  background: 'linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%)',
  backgroundSize: '800px auto'
}

export default {
  sideBar: {
    minWidth: 435,
    width: 435,
    height: '100vh',
    zIndex: 0,
    position: 'relative',
    borderLeft: '2px solid #eeeeee'
  },
  map: {
    position: 'relative',
    flex: '1 1 auto',
    height: 'calc(100vh - 67px)',
    zIndex: 1
  },
  topBar: {
    display: 'flex',
    background: 'white',
    height: 67,
    borderBottom: '2px solid #eeeeee',
    padding: '.8rem',
    zIndex: 5,
    userSelect: 'none'
  },
  wrapper: { flex: '1 1 auto' },
  inputWrapper: {
    display: 'inline-block',
    position: 'relative',
    flex: '1 1 auto'
  },
  logoWrapper: {
    display: 'inline-block',
    margin: '.7rem .8rem 0 0',
    verticalAlign: '3px',
    flex: '0 0 168px',
    '& img': { maxHeight: 40 }
  },
  loading,
  '@keyframes timeline': {
    '0%': { backgroundPosition: '-350px 0' },
    '100%': { backgroundPosition: '400px 0' }
  },
  projectTitle: {
    ...loading,
    display: 'inline-block',
    verticalAlign: 'top',
    height: 30,
    width: 250
  },
  projectInput: {
    height: 24,
    width: 244,
    margin: 3,
    background: 'white'
  },
  rightSideThings: { height: '100%' },
  rightSideButton: {
    ...loading,
    display: 'inline-block',
    verticalAlign: 'top',
    height: 30,
    width: 100
  },
  rightSideInnerButton: {
    height: 24,
    width: 94,
    margin: 3,
    background: 'white'
  },
  dropdown: {
    ...loading,
    display: 'inline-block',
    width: 76,
    height: 15,
    verticalAlign: 'middle',
    marginRight: 12.5
  },
  sidebarTitle: {
    ...loading,
    display: 'inline-block',
    height: 37,
    width: 433
  },
  sidebarTitleInner: {
    height: 31,
    width: 427,
    margin: 3,
    background: 'white'
  },
  sideBarTitleText: {
    ...loading,
    display: 'inline-block',
    width: '30%',
    height: 12,
    verticalAlign: 'sub',
    marginLeft: 12
  },
  generalPane: {
    padding: 20,
    height: 227
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/style.js